var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2915_30469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#5E5E5E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2915_30469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08975 17.0832C5.66881 17.0832 5.3125 16.9373 5.02083 16.6457C4.72917 16.354 4.58333 15.9977 4.58333 15.5767V4.99984H3.75V3.74986H7.49998V3.0127H12.5V3.74986H16.25V4.99984H15.4166V15.5767C15.4166 15.9977 15.2708 16.354 14.9791 16.6457C14.6875 16.9373 14.3312 17.0832 13.9102 17.0832H6.08975ZM7.83654 14.1665H9.08652V6.66651H7.83654V14.1665ZM10.9134 14.1665H12.1634V6.66651H10.9134V14.1665Z",
    fill: "#5E5E5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconDark);
export default __webpack_public_path__ + "static/media/delete_icon_dark.920906cbd6c16072fd31bce0ca217afa.svg";
export { ForwardRef as ReactComponent };